import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu } from "lucide-react";
import { FaLinkedin, FaInstagram, FaFacebook, FaYoutube } from "react-icons/fa";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => {
    if (path === "/") {
      return location.pathname === "/";
    }
    return location.pathname.startsWith(path);
  };

  return (
    <header className="bg-white sticky top-0 z-50 shadow-sm">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center">
            <Link to="/" className="flex items-center">
              <img src="assets/realation.png" alt="realation Logo" className="h-20 w-auto" />
            </Link>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            <Link
              to="/"
              className={`px-3 py-2 text-sm font-medium ${
                isActive('/') ? 'text-[#741112]' : 'text-gray-700 hover:text-[#741112]'
              }`}
            >
              Home
            </Link>
            <Link
              to="/about"
              className={`px-3 py-2 text-sm font-medium ${
                isActive('/about') ? 'text-[#741112]' : 'text-gray-700 hover:text-[#741112]'
              }`}
            >
              About Us
            </Link>
            <Link
              to="/services"
              className={`px-3 py-2 text-sm font-medium ${
                isActive('/services') ? 'text-[#741112]' : 'text-gray-700 hover:text-[#741112]'
              }`}
            >
              Services
            </Link>
            <Link
              to="/career"
              className={`px-3 py-2 text-sm font-medium ${
                isActive('/career') ? 'text-[#741112]' : 'text-gray-700 hover:text-[#741112]'
              }`}
            >
              Career
            </Link>
            <Link
              to="/contact"
              className={`px-3 py-2 text-sm font-medium ${
                isActive('/contact') ? 'text-[#741112]' : 'text-gray-700 hover:text-[#741112]'
              }`}
            >
              Contact Us
            </Link>
          </nav>

          {/* Desktop Social Media Icons */}
          <div className="hidden md:flex items-center space-x-4">
            <a href="https://www.linkedin.com/company/realation-official/" target="_blank" rel="noopener noreferrer">
              <FaLinkedin className="h-5 w-5 text-[#0A66C2]" />
            </a>
            <a href="https://www.instagram.com/realation_official?igsh=MXBieGhqNXg4ZDB6YQ==" target="_blank" rel="noopener noreferrer">
              <FaInstagram className="h-5 w-5 text-[#E1306C]" />
            </a>
            <a href="https://www.facebook.com/profile.php?id=100088421362780#" target="_blank" rel="noopener noreferrer">
              <FaFacebook className="h-5 w-5 text-[#1877F2]" />
            </a>
            <a href="https://www.youtube.com/@realation6580" target="_blank" rel="noopener noreferrer">
              <FaYoutube className="h-5 w-5 text-[#FF0000]" />
            </a>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-700 hover:text-[#741112] hover:bg-[#fbe9e9]"
            >
              <Menu className="h-6 w-6" />
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
              <Link
                to="/"
                className={`block px-3 py-2 rounded-md text-base font-medium ${
                  isActive('/') ? 'text-[#741112] bg-[#fbe9e9]' : 'text-gray-700 hover:text-[#741112] hover:bg-[#fbe9e9]'
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                Home
              </Link>
              <Link
                to="/about"
                className={`block px-3 py-2 rounded-md text-base font-medium ${
                  isActive('/about') ? 'text-[#741112] bg-[#fbe9e9]' : 'text-gray-700 hover:text-[#741112] hover:bg-[#fbe9e9]'
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                About Us
              </Link>
              <Link
                to="/services"
                className={`block px-3 py-2 rounded-md text-base font-medium ${
                  isActive('/services') ? 'text-[#741112] bg-[#fbe9e9]' : 'text-gray-700 hover:text-[#741112] hover:bg-[#fbe9e9]'
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                Services
              </Link>
              <Link
                to="/career"
                className={`block px-3 py-2 rounded-md text-base font-medium ${
                  isActive('/career') ? 'text-[#741112] bg-[#fbe9e9]' : 'text-gray-700 hover:text-[#741112] hover:bg-[#fbe9e9]'
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                Career
              </Link>
              <Link
                to="/blog"
                className={`block px-3 py-2 rounded-md text-base font-medium ${
                  isActive('/blog') ? 'text-[#741112] bg-[#fbe9e9]' : 'text-gray-700 hover:text-[#741112] hover:bg-[#fbe9e9]'
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                Blog
              </Link>
              <Link
                to="/contact"
                className={`block px-3 py-2 rounded-md text-base font-medium ${
                  isActive('/contact') ? 'text-[#741112] bg-[#fbe9e9]' : 'text-gray-700 hover:text-[#741112] hover:bg-[#fbe9e9]'
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                Contact Us
              </Link>

              {/* Mobile Social Icons */}
              <div className="flex justify-start space-x-4 pt-4 px-3">
                <a href="https://www.linkedin.com/company/realation-official/" target="_blank" rel="noopener noreferrer">
                  <FaLinkedin className="h-5 w-5 text-[#0A66C2]" />
                </a>
                <a href="https://www.instagram.com/realation_official?igsh=MXBieGhqNXg4ZDB6YQ==" target="_blank" rel="noopener noreferrer">
                  <FaInstagram className="h-5 w-5 text-[#E1306C]" />
                </a>
                <a href="https://www.facebook.com/profile.php?id=100088421362780#" target="_blank" rel="noopener noreferrer">
                  <FaFacebook className="h-5 w-5 text-[#1877F2]" />
                </a>
                <a href="https://www.youtube.com/@realation6580" target="_blank" rel="noopener noreferrer">
                  <FaYoutube className="h-5 w-5 text-[#FF0000]" />
                </a>
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
